import qs from 'qs';
import { select, put } from 'redux-saga/effects';
import CleansActions from './CleansRedux';
import { AuthSelectors } from './AuthRedux';

import API from '@utils/api';
import logger from '@utils/logger';
import { transformClean } from '@services/transform';
import { getCurrentMonth, getCurrentYear } from '@utils/date';

export function* loadMyCleansOfMonth(action) {
  const month = action.month || getCurrentMonth();
  const year = action.year || getCurrentYear();
  const state = yield select();
  const properties = yield select(AuthSelectors.selectUserProperties);

  try {
    yield put(CleansActions.setMyCleansLoading(true));
    const { result } = yield API.getMyCleans(month, year);

    const validCleans = result.filter(item => item.status !== 'canceled');

    const serviceTypeData = state.app.data.serviceTypes;
    const addonsData = state.app.data.addons;
    yield put(
      CleansActions.setMyCleansOfMonth(
        validCleans.map(item =>
          transformClean(item, serviceTypeData, addonsData, properties)
        ),
        month,
        year
      )
    );
    yield put(CleansActions.setMyCleansLoading(false));
  } catch (err) {
    //TODO: notify error
    logger.error(err);
  }
}

export function* loadMyCleansList() {
  const state = yield select();
  const properties = yield select(AuthSelectors.selectUserProperties);

  try {
    yield put(CleansActions.setMyCleansListLoading(true));
    const {
      result: { bookings }
    } = yield API.getMyLatestCleans();

    const serviceTypeData = state.app.data.serviceTypes;
    const addonsData = state.app.data.addons;

    const transformed = bookings
      .filter(item => item.status !== 'canceled')
      .map(item =>
        transformClean(item, serviceTypeData, addonsData, properties)
      );
    transformed.sort((a, b) => a.serviceDateTimestamp - b.serviceDateTimestamp);
    yield put(CleansActions.setMyCleansList(transformed));
    yield put(CleansActions.setMyCleansListLoading(false));
  } catch (err) {
    //TODO: notify error
    logger.error(err);
  }
}

export function* loadCleanDetail(action) {
  const { bookingId, searchParams } = action;

  let forceFetch = false;
  try {
    const qsParams = qs.parse(searchParams);
    let initialRate = qsParams['?rating'] || qsParams['rating'];

    forceFetch = !!initialRate;
  } catch (err) {
    forceFetch = false;
  }

  const state = yield select();
  const properties = yield select(AuthSelectors.selectUserProperties);

  const existingList = state.myCleans.list || [];
  const { currentMonth, currentYear, loaded: monthDataLoaded } = state.myCleans;
  const existingListOfMonth = state.myCleans.cleans || [];
  let cleanDetail = existingList.find(
    item => Number(item.bookingID) === Number(bookingId)
  );

  if (!cleanDetail) {
    cleanDetail = existingListOfMonth.find(
      item => Number(item.bookingID) === Number(bookingId)
    );
  }

  try {
    if (!cleanDetail || forceFetch) {
      const serviceTypeData = state.app.data.serviceTypes;
      const addonsData = state.app.data.addons;
      yield put(CleansActions.setMyCleansLoading(true));
      const { result } = yield API.getCleanDetail(bookingId);
      cleanDetail = transformClean(
        result,
        serviceTypeData,
        addonsData,
        properties
      );
    }

    yield put(CleansActions.setCurrentClean(cleanDetail));
    yield put(CleansActions.setMyCleansLoading(false));

    const { serviceYear, serviceMonth } = cleanDetail;
    if (
      !monthDataLoaded ||
      currentMonth !== serviceMonth ||
      currentYear !== serviceYear
    ) {
      yield put(
        CleansActions.setMyCleansOfMonthLoadRequest(serviceMonth, serviceYear)
      );
    }
  } catch (err) {
    //TODO: notify error
    logger.error(err);
  }
}

export function* updateCleanDetail(action) {
  const { bookingId, data } = action;
  const state = yield select();
  const properties = yield select(AuthSelectors.selectUserProperties);

  const serviceTypeData = state.app.data.serviceTypes;
  const addonsData = state.app.data.addons;
  const cleanDetail = transformClean(
    data,
    serviceTypeData,
    addonsData,
    properties
  );

  const newList = (state.myCleans.list || []).map(item =>
    Number(item.bookingID) === Number(bookingId) ? cleanDetail : item
  );

  const newCleansOfMonth = (state.myCleans.cleans || []).map(item =>
    Number(item.bookingID) === Number(bookingId) ? cleanDetail : item
  );

  yield put(CleansActions.setCurrentClean(cleanDetail));
  yield put(CleansActions.setMyCleansList(newList));
  yield put(
    CleansActions.setMyCleansOfMonth(
      newCleansOfMonth,
      state.myCleans.currentMonth,
      state.myCleans.currentYear
    )
  );
}
